import { CircularProgress, styled } from '@mui/material'
import Pages from 'components/DocumentDetail/Viewer/Pages'
import ViewerFooter from 'components/DocumentDetail/Viewer/ViewerFooter'
import { LOCAL_STORAGE_KEYS } from 'config'
import { Document } from 'entities/Documents'
import { useEffect, useState } from 'react'

const Container = styled('div')(({ theme }) => ({
  position: 'relative',
  height: '100%',
  width: '100%',
  backgroundColor: theme.palette.grey[400],
}))

const Loading = styled(CircularProgress)(({ theme }) => ({
  position: 'absolute',
  left: '50%',
  top: '50%',
  marginLeft: theme.spacing(-2),
  marginTop: theme.spacing(-2),
}))

const Main = styled('div')<{ loaded: boolean }>(({ loaded }) => ({
  opacity: loaded ? 1 : 0,
  display: 'flex',
  height: '100%',
  width: '100%',
  overflow: 'hidden',
  flexFlow: 'column nowrap',
  transition: 'opacity .2s',
}))

const SCALE_STEP = 0.1
const MIN_SCALE = 0.05

const Viewer = ({ detail }: { detail: Document }) => {
  const [loaded, setLoaded] = useState(false)

  // scale
  const [userScale, setUserScale] = useState(1)
  const localStorageViewerScale = localStorage.getItem(LOCAL_STORAGE_KEYS.viewerScale)
  useEffect(() => {
    if (localStorageViewerScale) {
      setUserScale(Number(localStorageViewerScale))
    }
  }, [localStorageViewerScale])

  const zoomIn = () => {
    updateScale(userScale + SCALE_STEP)
  }
  const zoomOut = () => {
    updateScale(Math.max(userScale - SCALE_STEP, MIN_SCALE))
  }
  const updateScale = (scale: number) => {
    setUserScale(scale)
    localStorage.setItem(LOCAL_STORAGE_KEYS.viewerScale, String(scale))
  }

  return (
    <Container>
      {!loaded && <Loading />}

      <Main loaded={loaded}>
        <Pages detail={detail} userScale={userScale} onLoad={() => setLoaded(true)} />

        <ViewerFooter scale={userScale} onZoomInClick={zoomIn} onZoomOutClick={zoomOut} />
      </Main>
    </Container>
  )
}

export default Viewer
